const selectStyles = (theme: any) => ({
  ...theme.typography.body1, // or theme.typography.label if you defined one
  '& #mui-component-select-employment-status-list': {
    color: theme.palette.primary[10] || theme.palette.text.primary
  }
})

export default selectStyles
